<template>
  <div class="login-container">
    <div class="login-bg-circle-dot">
      <div v-if="loginGrantType === 'password'" class="login-weaper  animated bounceInDown">
        <div class="login-left">
        </div>
        <div class="login-border">
          <div class="login-main">
            <userLogin v-if="activeName==='user'"></userLogin>
          </div>
        </div>
      </div>
      <div class="login-bottom">
        <div class="login-bottom-wrapper">
          <i class="icon-public-security"/>
          <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" class="text">沪ICP备11006368号-14</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import '@/styles/login.scss'
  import userLogin from "./userlogin";
  import {mapGetters} from "vuex";
  import {loginByIdentity} from '@/api/login'
  import {getStore, setStore} from "@/util/store";
  import {dateFormat} from "@/util/date";
  import {validatenull} from "@/util/validate";
  import {mcTokenUrl, loginGrantType} from '@/config/env'

  export default {
    name: "login",
    components: {
      userLogin
    },
    data() {
      return {
        activeName: "user"
      };
    },
    watch: {},
    created() {
      if (loginGrantType === 'production_sso') {
        var url = window.location.href;
        var identity = this.$route.query.identity;
        var random = new Date().getTime();
        if (identity) {
            new Promise((resolve, reject) => {
              loginByIdentity(identity, random).then(response => {
                const data = response.data
                this.$store.commit('SET_ACCESS_TOKEN', data.access_token)
                this.$store.commit('SET_REFRESH_TOKEN', data.refresh_token)
                this.$store.commit('SET_EXPIRES_IN', data.expires_in)
                this.$store.commit('CLEAR_LOCK')
                window.location.replace('/')
                resolve();
              }).catch(error => {
                this.$message({
                  message: '你的账号没有权限登录该系统。',
                  type: 'error'
                })
                reject(error);
              })
          });
        } else {
          window.location.replace(mcTokenUrl + '?redirectUrl=' + encodeURIComponent(url));
        }
      }
    },
    mounted() {
    },
    computed: {
      ...mapGetters(["website"])
    },
    props: [],
    methods: {}
  };
</script>
